import { useAuthGuardContext } from "~/route-guards/withAuthGuard";
import { useRecord } from "./useRecord";
import { useMemo } from "react";
import { generateRecordId } from "libs/schema";

export function useThreadReadReceipt(props: { threadId?: string | null }) {
  const { currentUserId } = useAuthGuardContext();

  const id = useMemo(() => {
    if (!props.threadId) return null;

    return generateRecordId("thread_read_receipt", {
      thread_id: props.threadId,
      user_id: currentUserId,
    });
  }, [props.threadId, currentUserId]);

  return useRecord("thread_read_receipt", id, { name: "useThreadReadReceipt" });
}
